import * as React from 'react';

import type {ProductMap, ProductMapPatch} from 'nutshell-core/types';

import {FormattedNumberField} from 'shells/formatted-number-field/formatted-number-field';
import {TextField} from 'shells/textfield/textfield';

import styles from './editable-product-map-row.module.css';

type Props = {
    productMap: ProductMap;
    onChange: (productMapPatch: ProductMapPatch) => any;
};

/*
Controlled component to display a productMaps name alongside editable quantity
and amount textfields.
 */
export class EditableProductMapRow extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles.container}>
                <div className={styles['product-name']}>{this.props.productMap.name}</div>
                <div className={styles['product-quantity']}>
                    <TextField
                        type='number'
                        onChange={this.handleQuantityChange}
                        value={String(this.props.productMap.quantity)}
                    />
                </div>
                <div className={styles['product-price']}>
                    <FormattedNumberField
                        onChange={this.handlePriceChange}
                        value={Number(this.props.productMap.price.amount)}
                    />
                </div>
            </div>
        );
    }

    handleQuantityChange = (newQuantity: string) => {
        this.props.onChange({
            id: this.props.productMap.id,
            quantity: Number(newQuantity),
            price: {
                currency: this.props.productMap.price.currency,
                amount: this.props.productMap.price.amount,
            },
        });
    };

    handlePriceChange = (newAmount?: number | null) => {
        // FormattedNumberField only returns `null` when the value is cleared,
        // which we don't allow here. This null check is just to satisfy flow
        const stringAmount = newAmount ? String(newAmount) : '0';

        this.props.onChange({
            id: this.props.productMap.id,
            quantity: this.props.productMap.quantity,
            price: {
                currency: this.props.productMap.price.currency,
                amount: stringAmount,
            },
        });
    };
}
